var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Input } from 'root/src/client/v2/common/components/ui/input';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from 'root/src/client/v2/common/components/ui/tooltip';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Password field with a show/hide toggle. The MUI icon spins/scales between states (no hard swap).
export const PasswordInput = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const [show, setShow] = useState(false);
    const label = show ? 'Hide password' : 'Show password';
    const ToggleIcon = show ? VisibilityOffIcon : VisibilityIcon;
    return (<div className="relative">
			<Input ref={ref} type={show ? 'text' : 'password'} className={cn('pr-9', className)} {...props}/>
			<TooltipProvider delayDuration={300}>
				<Tooltip>
					<TooltipTrigger asChild>
						<button type="button" onClick={() => setShow(value => !value)} aria-label={label} className="absolute right-2.5 top-1/2 flex -translate-y-1/2 text-muted-foreground/30 transition-colors hover:text-muted-foreground">
							<AnimatePresence mode="wait" initial={false}>
								<motion.span key={show ? 'off' : 'on'} initial={{ opacity: 0, rotate: -90, scale: 0.3 }} animate={{ opacity: 1, rotate: 0, scale: 1 }} exit={{ opacity: 0, rotate: 90, scale: 0.3 }} transition={{ duration: 0.18, ease: 'easeOut' }} className="flex">
									<ToggleIcon sx={{ fontSize: 16 }}/>
								</motion.span>
							</AnimatePresence>
						</button>
					</TooltipTrigger>
					<TooltipContent>{label}</TooltipContent>
				</Tooltip>
			</TooltipProvider>
		</div>);
});
PasswordInput.displayName = 'PasswordInput';
